import { createContext } from 'react';

const FocusedLocalCallContext = createContext(undefined);

export default FocusedLocalCallContext;
